// Custom React hook to fetch scheduled services for today
console.log('useScheduledServicesToday loaded');
import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function useScheduledServicesToday(truckId, techId, reloadTrigger = 0, showAll = false) {
  const [scheduledServicesToday, setScheduledServicesToday] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    const url = `${API_URL}/api/scheduled-services/today${showAll ? '?override=true' : ''}`;
    axios.get(url)
      .then(res => {
        // Store the full array of scheduled service objects
        setScheduledServicesToday(res.data);
      })
      .catch(() => setError('Failed to fetch scheduled services for today'))
      .finally(() => setLoading(false));
  }, [reloadTrigger]);

  return { scheduledServicesToday, loading, error };
}
